<template>
    <div v-if="mode === 'coupon'" class="adTile coupon">
        <slot name="coupon"></slot>
    </div>
    <div v-else-if="mode === 'html'" :class="config.cssClass" class="adTile plainHtml">
        <div v-html="plainHtml"></div>
        <span class="countdown" v-if="config.adTile.valid == 'true'" v-html="config.longHeadline"></span>
    </div>
    <div v-else class="adTile currentSale" 
                :class="'d' + doy" 
                :style="'background-color:var(--actionbar-bk);background-size:cover;background-image: url(' + backgroundimage + ');'"></div>
</template>
<script>
import * as moment from 'moment';
export default {
    props:
    {
        type:
        {
            type: String,
            default: 'coupon' // coupon | sale
        },
        backgroundimage:
        {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            
        }
    },
    computed: {
       mode()
       {
            return App.bkconfig.shopSale.tileMode || 'coupon';
       },
       config() 
       {
            return App.bkconfig.shopSale;
       },
        endDay()
        {
            if(this.config.enddate == null)
                return null;
            
            let date = moment(this.config.enddate, 'YYYY-MM-DD')
            return date.dayOfYear();        
        },
        countdownText() {
            let text = "";

            if(this.endDay !== null && (this.endDay + 1) >= this.doy)
            {
                // we have an end-date set and it is in the future.
                // From 4 days diff, start showing countdown
                switch (this.doy) {
                    case (this.endDay - 4):
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown4');
                        break;
                    case (this.endDay - 3):
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown3');
                        break;
                    case (this.endDay - 2):
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown2');
                        break;
                    case (this.endDay - 1):
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown1');
                        break;
                    case this.endDay:
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown0');
                        break;
                    case (this.endDay + 1): // for day after end
                        text = this.$translate('biokinderDesign::Sale.bkSalesCouponCountdown0');
                        break;
                }
            }

            if (this.config.defaultCountdownText !== null && this.config.defaultCountdownText != "" && text == "") {
                text = this.config.defaultCountdownText;
            } 
            if(text == "") {
                text = "Nur für kurze Zeit!";
            }
            return text;
        },
       doy()
        {
            let today = moment();
            return today.dayOfYear();
        },
       plainHtml() {
            return App.bkconfig.shopSale.adTile.plainHtml || '';
       },
    }
}
</script>
